import { render, staticRenderFns } from "./ClashingRooms.vue?vue&type=template&id=7983a29c&"
import script from "./ClashingRooms.vue?vue&type=script&lang=ts&"
export * from "./ClashingRooms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports